<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
	book: Object,
	dark: {
		type: Boolean,
		default: false
	},
	hideExtra: {
		type: Boolean,
		default: false
	}
});


const formattedRuntime = computed(() => {
	let seconds = props.book?.runtime || 0;

	let runtimeH = Math.floor(seconds / 60 / 60);
	let runtimeM = Math.floor(seconds / 60 - runtimeH * 60);
	let runtimeS = Math.floor(seconds - runtimeH * 60 * 60 - runtimeM * 60);

	let label = '';
	if (runtimeH > 0) {
		label += `${runtimeH}${runtimeH !== 1 ? 'h' : 'h'}`;
	}
	if (runtimeM > 0) {
		label += ` ${runtimeM}${runtimeM !== 1 ? 'm' : 'm'}`;
	}

	return label;
});

</script>

<template>
	<div class="BookMeta">
		<div class="label" :class="dark ? 'dark:text-gray-400' : ''">
			{{ book.is_abridged ? 'Abridged' : 'Unabridged' }} {{ book.format }}
		</div>
		<h1 class="mt-gr-7 sm:mt-0 text-3xl font-bolder leading-gr-7"
			:class="dark ? 'bg-clip-text bg-gradient-to-br from-white to-secondary-100 text-transparent' : ''">
			{{ book.title }}
		</h1>
		<h2 v-if="book.subtitle" class="text-2xl leading-gr-7" :class="dark ? 'text-white' : ''">
			{{ book.subtitle }}
		</h2>
		<span v-if="book.author_list" :href="route('browse') + `#/selectedAuthors=${book.author_list.replace(', ', ',')}`"
			class="block mt-gr-5 font-bold group" :class="dark ? 'text-white' : ''">
			<i class="fa-light fa-fw fa-pen-line mr-gr-3" title="Written by"></i>
			<span class="">{{ book.author_list }}</span>
			<!-- <span class="group-hover:underline">{{ book.author_list }}</span> -->
		</span>
		<span v-if="book.narrator_list"
			:href="route('browse') + `#/selectedNarrators=${book.narrator_list.replace(', ', ',')}`"
			class="block opacity-50 font-bold duration-300 group" :class="dark ? 'text-white' : ''">
			<!-- class="block opacity-50 font-bold hover:opacity-100 duration-300 group" -->
			<i class="fa-light fa-fw fa-waveform mr-gr-3" title="Read by"></i>
			<span class="">{{ book.narrator_list }}</span>
			<!-- <span class="group-hover:underline">{{ book.narrator_list }}</span> -->
		</span>
		<span v-if="book.publisher_list" :href="route('browse') + `#/selectedPublishers=${book.publisher_list.replace(', ', ',')}`
			" class="block opacity-50 font-bold duration-300 group" :class="dark ? 'text-white' : ''">
			<i class="fa-light fa-fw fa-books mr-gr-3" title="Published by"></i>
			<span class="">{{ book.publisher_list }}</span>
			<!-- <span class="group-hover:underline">{{ book.publisher_list }}</span> -->
		</span>
		<div v-if="!props.hideExtra && (book.runtime || book.language || book.isbn)"
			class="label flex divide-x items-center justify-center sm:justify-start sm:-ml-gr-3 divide-gray-500 leading-none mt-gr-6"
			:class="dark ? 'dark:text-gray-400' : ''">
			<div v-if="book.runtime" class="text-gray-400 px-gr-3">{{ formattedRuntime }}</div>
			<div v-if="book.language" class="px-gr-3">{{ book.language }}</div>
			<div v-if="book.isbn" class="px-gr-3">
				ISBN: <span class="whitespace-nowrap">{{ book.isbn }}</span>
			</div>
		</div>
	</div>
</template>